
import Branchbar from "~/components/branches/branchbar";
import Rates from "~/components/rates";
import Servicelistplaceholder from "~/components/placeholders/servicelistplaceholder";
import products from "~/models/products";
import Foot from "@/layouts/foot";
export default {
  name: "index",
  components: {Foot, Servicelistplaceholder, Rates, Branchbar},
  data() {
    return {
      branches: [],
      totalPage: '',
      totalCount: 0,
      placeholder: true,
      branchNull: false,
      execute: false
    }
  },
  head() {
    return {
      title: 'Μεταπωλητές',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: "Bulunduğunuz şehirdeki servis noktalarına Tirelet ayrıcalıklarıyla erişin."
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: "servislet  ankara lastik, istanbul lastik, izmir lastik, kadıköy lastik servisi, çankaya lastik servisi, sarıyer lastik servisi, ataşehir lastik servisi  "
        }
      ],
    }
  },
  computed: {
    city: {
      get() {
        return this.$store.state.city.slug
      },
      set(value) {
        localStorage.setItem("city", value)
        this.$store.commit('city/setCitySlug', value)
      },
    }
  },
  fetchKey: 'branchbar',
  watch: {
    '$route.query': '$fetch',
  },
  async fetch() {
    try {
      this.branchNull = false
      if (!this.$route.query.page) {
        this.$route.query.page = 1
      }
      if (this.$route.query.page === 1) {
        this.branches = []
        var url = `/home-page/branches/by-branch-group-slug?pagination[limit]=10&pagination[page]=1`
        if (this.city) {
          var url = url + `&city_slug=${this.city || ''}`
        } else if (this.$route.query.city) {
          var url = url + `&city_slug=${this.$route.query.city || ''}`
        }
        if (this.$route.query.brand) {
          var url = url + `&branch_group_slug=${this.$route.query.brand || ''}`
        }
        if (this.$route.query.district) {
          var url = url + `&district_slug=${this.$route.query.district || ''}`
        }

        if (this.$route.query.search_text) {
          var url = url + `&filter_like_name=${this.$route.query.search_text || ''}`
        }

        var branches = await this.$http.$get(url)
        this.branches = branches.data.branches.items
        this.totalPage = branches.data.branches.pagination.total_page
        this.totalCount = branches.data.branches.pagination.total
      } else {
        var url = `/home-page/branches/by-branch-group-slug?pagination[limit]=10&pagination[page]=${this.$route.query.page}`
        if (this.city) {
          var url = url + `&city_slug=${this.city || ''}`
        }
        if (this.$route.query.brand) {
          var url = url + `&branch_group_slug=${this.$route.query.brand || ''}`
        }
        if (this.$route.query.district) {
          var url = url + `&district_slug=${this.$route.query.district || ''}`
        }

        if (this.$route.query.search_text) {
          var url = url + `&filter_like_name=${this.$route.query.search_text || ''}`
        }

        var response = await this.$http.$get(url)
        if (response.code === 1000) {
          response.data.branches.items.forEach((branch) => {
            this.branches.push(branch)
          })
          this.totalPage = response.data.branches.pagination.total_page
          this.totalCount = response.data.branches.pagination.total
        }
      }

      if (this.branches.length === 0) {
        this.branchNull = true
      }
    }catch (e) {
      this.$router.push(this.localePath({name: 'miscellaneous-error'}))
    }
  },
  methods: {
    setTitle(title) {
      document.title = title + ' | Tirelet'
    },
    changeUrl(merchant, city) {
      this.$cookies.set('city', this.$nuxt.$helpers.slugify(city))
      this.$store.commit('city/setCitySlug', this.$nuxt.$helpers.slugify(city))
      this.$router.push(this.localePath({name: 'branch', params: {branch: merchant}}))
    },
    async infiniteScroll($state) {
      if (!this.execute) {
        if (this.branches.length > 0) {
          if (this.totalPage > this.$route.query.page) {
            setTimeout(() => {
              var nextPage = (parseInt(this.$route.query.page) + 1)
              this.$route.query.page = nextPage
              var url = new URL(window.location.href);
              url.searchParams.set('page', (this.$route.query.page))
              window.history.pushState({}, '', url);
              this.$fetch().then(() => {
                $state.loaded();
                this.execute = false
              })
            },500)
          } else {
            $state.complete();
          }
        }
      }
    },
  }
}
